import { getString } from "../common/common";

export const SEARCH = "SEARCH";
export const FOOTER_COMP_INFO = "FOOTER_COMP_INFO";
export const TRIP_CODE = "TRIP_CODE";
export const DEPARTURE_TIME = "DEPARTURE_TIME";
export const BUS_PNR = 'Bus_PNR';
export const ENQ = 'Enquiry';
export const OB_REF = 'OB_Reference';
export const MOBILE_BASED = 'Mobile_Based';
export const EMAIL_BASED = 'Email_ID_Based';
export const MOBILE_EMAIL_BASED_ENQ = 'Mobile_Email_ID_Based';
export const BUS_SER = 'Bus_Service';
export const BUS_TICKET_BOOKING = 'Bus_Ticket_Booking';
export const TOUR_PACKAGE_BOOKING = 'Tour_Package_Booking';
export const BUS_TRUCK_HIRE = 'Bus_Truck_Hire';
export const CARGO_BOOKING = 'Cargo_Booking';
export const OK = 'OK';
export const RESULT_NOT_FOUND = "RESULT_NOT_FOUND";
export const TO = "TO";
export const PLEASE_MODIFY_SEARCH = "PLEASE_MODIFY_SEARCH";
export const ADVANCE_BOOKING = "ADVANCE_BOOKING";
export const LOCKOTP_MSG = "LOCKOTP_MSG";
export const OR = "OR";
export const CONNECT_BUS_OPTION = "CONNECT_BUS_OPTION";

export const translations = {
  en: {
    [SEARCH]: "Search",
    [FOOTER_COMP_INFO]: `Karnataka State Road Transport Corporation - KSRTC | Powered by Amnex & Mantis`,
    [TRIP_CODE]: "TripCode",
    [DEPARTURE_TIME]: "Departure Time",
    [BUS_PNR]: "Bus PNR",
    [ENQ]: "Enquiry",
    [OB_REF]: "OB Reference",
    [MOBILE_BASED]: "Mobile Based",
    [EMAIL_BASED]: "Email ID Based",
    [MOBILE_EMAIL_BASED_ENQ]: "Mobile/Email ID Based Enquiry",
    [BUS_SER]: "Bus Service",
    [BUS_TICKET_BOOKING]: "Bus Ticket Booking",
    [TOUR_PACKAGE_BOOKING]: "Tour Package Booking",
    [BUS_TRUCK_HIRE]: "Bus Truck Hire",
    [CARGO_BOOKING]: "Cargo Booking",
    [OK]: "OK",
    [RESULT_NOT_FOUND]: "Sorry! There were no results found for",
    [TO]: "to",
    [PLEASE_MODIFY_SEARCH]: "Please Modify your Search",
    [ADVANCE_BOOKING]:"Advance booking is allowed for 30 days.",
    [LOCKOTP_MSG]:"OTP validation service has been locked for next 30 minutes due to too many failed attempts.",
    [OR]: "or",
    [CONNECT_BUS_OPTION]: "Click Here for Connecting Bus Options",
  },
  kn: {
    [FOOTER_COMP_INFO]: `Karnataka State Road Transport Corporation - KSRTC | Powered by Amnex & Mantis`,
    [SEARCH]: "ಹುಡುಕಿ",
    [TRIP_CODE]: "ಟ್ರಿಪ್‌ಕೋಡ್",
    [DEPARTURE_TIME]: "ನಿರ್ಗಮನ ಸಮಯ",
    [BUS_PNR]: "ಬಸ್ PNR",
    [ENQ]: "ವಿಚಾರಣೆ",
    [OB_REF]: "ಓಬಿ ಉಲ್ಲೇಖ ಸಂಖ್ಯೆ",
    [MOBILE_BASED]: "ಮೊಬೈಲ್ ಆಧಾರಿತ",
    [EMAIL_BASED]: "ಇಮೇಲ್ ಐಡಿ ಆಧಾರಿತ",
    [MOBILE_EMAIL_BASED_ENQ]: "ಮೊಬೈಲ್/ಇಮೇಲ್ ಐಡಿ ಆಧಾರಿತ ವಿಚಾರಣೆ",
    [BUS_SER]: "ಬಸ್ ಸೇವೆ",
    [BUS_TICKET_BOOKING]: "ಬಸ್ ಟಿಕೆಟ್ ಬುಕಿಂಗ್",
    [TOUR_PACKAGE_BOOKING]: "ಟೂರ್  ಪ್ಯಾಕೇಜ್ ಬುಕಿಂಗ್",
    [BUS_TRUCK_HIRE]: "ಬಸ್ / ಟ್ರಕ್ ಬಾಡಿಗೆ",
    [CARGO_BOOKING]: "ಕಾರ್ಗೋ ಬುಕಿಂಗ್",
    [OK]: "ಸರಿ",
    [RESULT_NOT_FOUND]: "ಕ್ಷಮಿಸಿ! ಯಾವುದೇ ಫಲಿತಾಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    [TO]: "ಇವರಿಗೆ",
    [PLEASE_MODIFY_SEARCH]: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹುಡುಕಾಟವನ್ನು ಮಾರ್ಪಡಿಸಿ",
    [ADVANCE_BOOKING]:"Advance booking is allowed for 30 days.",
    [LOCKOTP_MSG]:"OTP validation service has been locked for next 30 minutes due to too many failed attempts.",
    [OR]: "or",
    [CONNECT_BUS_OPTION]: "Click Here for Connecting Bus Options",
  },
};

export const tCommon = (key = "") => {
  return getString(key, translations);
};
